import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import './RadioButtonPanel.scss';

// Change RadioButtonPanel to the appropriate name
class RadioButtonPanel extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { buttonChange: false };
  }

  componentDidMount() {
  }

  componentDidUpate() {
  }

  // All event handlers or callback functions that need to have "this" available
  // Need to have "handle" (case in-sensitive) in the name. Matching names would be:
  //    handleResponse
  //    dateTimeHandler
  //    HandlesMessiah (not Handels however)
  handleClick(e) {
    const { handleClick, allowUnclick } = this.props;
    if (this.props.options) {
      const dataId = e.target.getAttribute('data-id');

      let optionSelector = null;
      for (var i = 0; i < this.props.options.length; i++)
      {
        let option = this.props.options[i];
        if (option.type != dataId) {
          option.value = false;
          option.checked = false;
        }
        else {
          optionSelector = option;
          if (allowUnclick && option.checked) {
            option.value = false;
            option.checked = false;
          }
          else {
            option.value = true;
            option.checked = true;
          }

        }
      } 
      this.setState({ buttonChanged: true });
      if (handleClick) {
        handleClick(optionSelector, this.props.item);
      }
    }
  }

  handleSubmit(e) {
    e.preventDefault();
  }

  render() {
    const { horizontal, panelLabel, panelLabelPosition, buttonLabelPosition, size, buttonHeight, buttonWidth, options } = this.props;

    if (this.state.buttonChanged) {
      this.state.buttonChanged = false;
    }

    let buttonStyle = {};
    if (buttonHeight || buttonWidth) {
      buttonStyle.height = buttonHeight;
      buttonStyle.width = buttonWidth;
    }
    const radioButtons = options.map(option => {
      if (this.props.textOnly) {
        return <div className="button-container" key={option.type} style={buttonStyle}>
          <label className={'radio-button ' + buttonLabelPosition}>
            <input className="hidden-button" type="radio"
              checked={option.checked}
              onChange={this.handleClick} data-id={option.type} />
            <div className={'visible-text ' + size + (option.checked ? ' selected' : '')} >{option.buttonLabel}</div>
            <div className="vertical-separator">|</div>
          </label>
        </div>;
      }  
      else {
        return <div className="button-container" key={option.type} style={buttonStyle}>
          <label className={'radio-button ' + buttonLabelPosition}>
            <input className="hidden-button" type="radio"
              checked={option.checked}
              onChange={this.handleClick} data-id={option.type} />
            <div className={'visible-button ' + size} />
            <div className={'button-label ' + size} >{option.buttonLabel}</div>
          </label>
        </div>;
      }  
    });

    return (
      <div className={'radio-button-panel-outer ' + (horizontal ? 'horizontal ' : 'vertical ') + panelLabelPosition}>
        <div className={'panel-label ' + size}>{panelLabel}</div>
        <form className="radio-button-panel" onSubmit={this.handleSubmit}>
          <div className={'panel-container ' + (horizontal ? 'horizontal' : 'vertical')}>
            {radioButtons }
          </div>
        </form>
      </div>  
    );
  }
}

export default (RadioButtonPanel);



// WEBPACK FOOTER //
// ./src/components/Buttons/RadioButtonPanel/index.js